import { PixiSticker } from "./pixi-sticker";

/**
 *  <Desription of Service here>
 *
 * @export
 * @class PixiManager
 */
export class PixiManager {
  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = [
    "$log",
    "$timeout",
    "$sce",
    "HeroManager",
    "UserAgentManager",
    "DataManager",
    "ProgressManager",
    "$rootScope",
    "TrackingManager",
    "AngularServices"
  ];
  public isReady: boolean = false;
  public assets: [string];
  public element: any;
  public renderer: any;
  public stage: any;
  public backgroundBoard: any;
  public stickerBoard: any;
  public heroBoard: any;
  public initialDimensions: any;
  public adjustedRatio: any;
  public clone: any;
  public heroURI: string = undefined;
  public brand_image: any;
  public brand_download_image: any;
  public isStickerInteraction: boolean = false;
  public displayPixi: boolean = true;
  public securityImage: any;

  /**
   * @param {$log} $log - Angular logging Service.
   */
  constructor(
    public $log: any,
    public $timeout: any,
    public $sce: any,
    public HeroManager: any,
    public UserAgentManager: any,
    public DataManager: any,
    public ProgressManager: any,
    public $rootScope: any,
    public TrackingManager: any,
    public AngularServices: any
  ) {
    this.$log = $log.getInstance("PixiManager", false);
    this.$log.debug("constructor");
    this.initialDimensions = {
      width: 954,
      height: 1458
    };

    this.$rootScope.$on("progress:stickers", (event, data) => {
      this.$timeout(() => {
        this.addSavedStickers(data.stickers);
      }, 1000);
    });

    this.$rootScope.$on("progress:coverBG", (event, data) => {
      this.$timeout(() => {
        this.setCover(data.coverBG);
      }, 1000);
    });
  }

  public resize(element) {
    this.$log.debug("onResize", this.initialDimensions);

    if (this.isReady) {
      let ew = element.offsetWidth;
      let eh = element.offsetHeight;
      this.renderer.resize(ew, eh);
      let ratio = Math.min(
        ew / this.initialDimensions.width,
        eh / this.initialDimensions.height
      );
      this.backgroundBoard.scale.set(ratio);
      this.stickerBoard.scale.set(ratio);
      this.heroBoard.scale.set(ratio);
      this.adjustedRatio = ratio;
      this.renderer.render(this.stage);
    }
  }

  public init(element) {
    this.$log.debug("init");
    this.element = element;

    this.brand_image = [];
    this.brand_image.push(new Image());
    this.brand_image[0].src =
      this.DataManager.config.settings.assetsPath + "common/brand-overlay.png";

    this.brand_download_image = [];
    this.brand_download_image.push(new Image());
    this.brand_download_image[0].src =
      this.DataManager.config.settings.assetsPath +
      "common/legalcopy-small.png";

    this.securityImage = [];
    this.securityImage.push(new Image());
    this.securityImage[0].src =
      this.DataManager.config.settings.assetsPath + "common/securityImage.png";

    // get all assets for cover making to preload into pixi
    let coverBackgroundCarousel = this.DataManager.config.carousels.filter(
      (value, index, array) => {
        return value.key === "coverBackgrounds";
      }
    )[0];
    let coverBackgrounds = coverBackgroundCarousel.items.map(asset => {
      return this.DataManager.config.settings.assetsPath + asset.image;
    });

    let coverStickerCarousel = this.DataManager.config.carousels.filter(
      (value, index, array) => {
        return value.key === "coverStickers";
      }
    )[0];
    let coverStickers = coverStickerCarousel.items.map(asset => {
      return this.DataManager.config.settings.assetsPath + asset.image;
    });

    this.assets = coverBackgrounds.concat(coverStickers);

    this.renderer = new PIXI.CanvasRenderer(954, 1458, {
      autoResize: true,
      transparent: true,
      antialias: true,
      resolution: 2,
      roundPixels: true
    });
    this.stage = new PIXI.Container();
    this.element.appendChild(this.renderer.view);

    // load the assets
    PIXI.loader.add(this.assets).load(this.assetsLoaded.bind(this));
  }

  public assetsLoaded() {
    this.$log.debug("assetsLoaded", this.assets);

    this.backgroundBoard = new PIXI.Container();
    let backgroundArt = new PIXI.Sprite(
      PIXI.loader.resources[this.assets[0]].texture
    );

    this.backgroundBoard.addChild(backgroundArt);
    // adding 25 pixels to fill canvas with the background image
    this.backgroundBoard.children[0].width = this.initialDimensions.width + 25;
    this.backgroundBoard.children[0].height =
      this.initialDimensions.height + 25;
    this.stage.addChild(this.backgroundBoard);

    this.stickerBoard = new PIXI.Container();
    this.stickerBoard.bringToFront = this.bringToFront;
    this.stage.addChild(this.stickerBoard);

    this.heroBoard = new PIXI.Container();
    this.heroBoard.bringToFront = this.bringToFront;
    this.stage.addChild(this.heroBoard);

    this.updateRender();
    this.isReady = true;
    this.resize(this.element);
  }

  public setCover(url, sendReport: boolean = false) {
    let path = this.DataManager.config.settings.assetsPath + url;
    if (url === "") {
      path = this.assets[0];
    }

    this.$log.debug("setCover", path);
    let backgroundArt = new PIXI.Sprite(PIXI.loader.resources[path].texture);
    this.backgroundBoard.removeChildAt(0);
    this.backgroundBoard.addChild(backgroundArt);
    this.backgroundBoard.children[0].width = this.initialDimensions.width;
    this.backgroundBoard.children[0].height =
      this.initialDimensions.height + 10;

    this.updateRender();
    this.resize(this.element);

    this.ProgressManager.setCoverBG(url);
    if (sendReport) {
      let backgroundFile = url.toString().split("/");
      let backgroundName = backgroundFile[1].split(".");
      this.TrackingManager.trackBackground(backgroundName[0]);
    }
  }

  public addSavedStickers(stickers: Array<any>) {
    //loop through all saved stickers and add them
    for (let sticker of stickers) {
      if (sticker.isHero) {
        this.addSavedHeroToCover(sticker);
      } else {
        this.addSavedSticker(sticker);
      }
    }
  }

  public addSavedHeroToCover(sticker: any) {
    let self = this;

    let options: any = {
      name: sticker.name,
      url: sticker.url,
      container: this.stickerBoard,
      element: this,
      scale: { x: 1, y: 1 },
      rotation: sticker.rotation,
      x: 400,
      y: 750,
      width: 582 + 582 * 0.5,
      height: 900 + 900 * 0.5,
      isHero: true,
      isTouchCapable: this.UserAgentManager.isTouchCapable(),
      controlIconPaths: {
        rotate:
          this.DataManager.config.settings.assetsPath + "icons/icon-rotate.png",
        resize:
          this.DataManager.config.settings.assetsPath + "icons/icon-scale.png",
        trash:
          this.DataManager.config.settings.assetsPath + "icons/icon-trash.png"
      }
    };

    // check if there is already a hero image on the board
    if (this.heroBoard.children.length) {
      let heroStickers: any = this.heroBoard.children.filter(
        (element, index, array) => {
          return element.isHero === true;
        }
      );

      let existingHeroSticker: any = heroStickers[0];
      if (existingHeroSticker !== undefined) {
        this.heroBoard.removeChild(existingHeroSticker);
      }
    }

    // save the uri for future reference
    this.heroURI = sticker.url;
    let s: any = new PixiSticker(
      options,
      function() {
        self.heroBoard.addChild(this.sprite);
        self.renderContainer();
      },
      this.progressCallback.bind(this)
    );
  }

  public addHeroToCover() {
    let self = this;

    let heroValues: any = {
      scale: {
        x: 1,
        y: 1
      },
      rotation: 0,
      x: 200,
      y: 330
    };

    let options: any = {
      name: this.generateRandomStickerID(),
      url: this.HeroManager.heroImageData,
      container: this.stickerBoard,
      element: this,
      scale: heroValues.scale,
      rotation: heroValues.rotation,
      x: 400,
      y: 750,
      width: 582 + 582 * 0.5,
      height: 900 + 900 * 0.5,
      isHero: true,
      isTouchCapable: this.UserAgentManager.isTouchCapable(),
      controlIconPaths: {
        rotate:
          this.DataManager.config.settings.assetsPath + "icons/icon-rotate.png",
        resize:
          this.DataManager.config.settings.assetsPath + "icons/icon-scale.png",
        trash:
          this.DataManager.config.settings.assetsPath + "icons/icon-trash.png"
      }
    };
    if (this.heroURI !== options.url) {
      // check if there is already a hero image on the board
      let heroStickers: any = this.heroBoard.children.filter(
        (element, index, array) => {
          return element.isHero === true;
        }
      );
      let existingHeroSticker: any = heroStickers[0];
      if (existingHeroSticker !== undefined) {
        // capture values to apply to persist any sticker modifications
        heroValues.scale.x = existingHeroSticker.children[0].scale.x;
        heroValues.scale.y = existingHeroSticker.children[0].scale.y;
        heroValues.rotation = existingHeroSticker.rotation;
        heroValues.x = existingHeroSticker.x;
        heroValues.y = existingHeroSticker.y;

        // remove the sticker
        this.heroBoard.removeChild(existingHeroSticker);
      }

      this.heroURI = options.url;
      let s: any = new PixiSticker(
        options,
        function() {
          self.heroBoard.addChild(this.sprite);
          self.renderContainer();
        },
        this.progressCallback.bind(this)
      );
    }
  }

  public progressCallback(details): void {
    this.$log.debug("progressCallback", details);

    let sticker: any = {
      name: details.name,
      url: details.url,
      rotation: details.rotation,
      x: details.position.x,
      y: details.position.y,
      width: details.width,
      height: details.height,
      isHero: details.isHero,
      shouldDelete: details.shouldDelete
    };

    this.ProgressManager.setSticker(sticker);
  }

  public addSavedSticker(sticker: any): void {
    this.$log.debug("addSavedSticker", sticker);
    let self = this;

    let options: any = {
      name: sticker.name,
      url: sticker.url,
      container: this.stickerBoard,
      element: this,
      scale: { x: 1, y: 1 },
      rotation: sticker.rotation,
      x: sticker.x,
      y: sticker.y,
      width: sticker.width,
      height: sticker.height,
      isHero: false,
      isTouchCapable: this.UserAgentManager.isTouchCapable(),
      controlIconPaths: {
        rotate:
          this.DataManager.config.settings.assetsPath + "icons/icon-rotate.png",
        resize:
          this.DataManager.config.settings.assetsPath + 'icons/icon-scale.png',
        trash:
          this.DataManager.config.settings.assetsPath + 'icons/icon-trash.png'
      }
    };

    let s = new PixiSticker(
      options,
      function() {
        self.stickerBoard.addChild(this.sprite);
        self.renderContainer();
      },
      this.progressCallback.bind(this)
    );
  }

  public generateRandomStickerID(): string {
    let id = '';
    let possible =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < 25; i++) {
      id += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return id;
  }

  public addSticker(sticker: any): void {
    this.$log.debug('addSticker', sticker);
    let self = this;

    let options: any = {
      name: this.generateRandomStickerID(),
      url: this.DataManager.config.settings.assetsPath + sticker.image,
      container: this.stickerBoard,
      element: this,
      scale: { x: 0.5, y: 0.5 },
      rotation: 0,
      x: 300,
      y: 300,
      width: sticker.dimensions[0],
      height: sticker.dimensions[1],
      isHero: false,
      isTouchCapable: this.UserAgentManager.isTouchCapable(),
      controlIconPaths: {
        rotate:
          this.DataManager.config.settings.assetsPath + 'icons/icon-rotate.png',
        resize:
          this.DataManager.config.settings.assetsPath + 'icons/icon-scale.png',
        trash:
          this.DataManager.config.settings.assetsPath + 'icons/icon-trash.png'
      }
    };

    let stickerFile = sticker.image.toString().split('/');
    let stickerName = stickerFile[1].split('.');
    this.TrackingManager.trackStickers(stickerName[0]);

    // add updated hero image to stickerboard
    let s = new PixiSticker(
      options,
      function() {
        self.stickerBoard.addChild(this.sprite);
        self.renderContainer();
      },
      this.progressCallback.bind(this)
    );
  }

  public bringToFront(sprite) {
    if (sprite.parent) {
      let parent = sprite.parent;
      parent.removeChild(sprite);
      parent.addChild(sprite);
    }
  }

  public renderContainer() {
    this.renderer.render(this.stage);
  }

  public updateRender() {
    requestAnimationFrame(() => {
      this.renderContainer();
      this.updateRender();
    });
  }

  public generateCover() {
    let data = this.renderer.view.toDataURL('image/png');

    let c: any = document.createElement('canvas');
    let ctx = c.getContext && c.getContext('2d');
    ctx.mozImageSmoothingEnabled = false;
    ctx.webkitImageSmoothingEnabled = false;
    ctx.msImageSmoothingEnabled = false;
    ctx.imageSmoothingEnabled = false;
    // cover size = 456 × 693
    c.width = 2295;
    c.height = 3508;

    ctx.drawImage(this.renderer.view, 0, 0, c.width, c.height);

    // this uses canvg to get around the IE tainted canvas issue while adding svg's to a canvas.
    // we have been working around the IE tainted canvas issue for a couple projects and this is the ONLY approach we have found
    // which lets us get around it without having an image proxy server, or a lamda function. See PPG-ME for the lamba.
    // https://github.com/gabelerner/canvg
    let c2: any = document.createElement('canvas');
    c2.width = 2295;
    c2.height = 3508;
    let ctx2 = c2.getContext && c2.getContext('2d');
    ctx2.drawImage(this.brand_image[0], 16, -30, 2295, 3508);

    let cs: any = document.createElement('canvas');
    cs.width = 5;
    cs.height = 1;
    let ctxs = cs.getContext && cs.getContext('2d');
    ctxs.drawImage(this.securityImage[0], 0, 0);

    let c3: any = document.createElement('canvas');
    c3.width = 2295;
    c3.height = 3508;

    let ctx3 = c3.getContext && c3.getContext('2d');
    ctx3.mozImageSmoothingEnabled = false;
    ctx3.webkitImageSmoothingEnabled = false;
    ctx3.msImageSmoothingEnabled = false;
    ctx3.imageSmoothingEnabled = false;

    ctx3.drawImage(c, 0, 0, 2295, 3508);
    ctx3.drawImage(c2, 10, 20, 2295, 3508);
    ctx3.drawImage(cs, 0, 0);

    let fullSizeCover = c3.toDataURL('image/png');
    return fullSizeCover;
  }

  public generateDownloadCover() {
    let data = this.renderer.view.toDataURL('image/png');
    let c: any = document.createElement('canvas');
    let ctx = c.getContext && c.getContext('2d');
    ctx.mozImageSmoothingEnabled = false;
    ctx.webkitImageSmoothingEnabled = false;
    ctx.msImageSmoothingEnabled = false;
    ctx.imageSmoothingEnabled = false;
    c.width = 954;
    c.height = 1458;
    ctx.drawImage(this.renderer.view, 0, 0, c.width, c.height);
    let c2: any = document.createElement('canvas');
    c2.width = 954;
    c2.height = 1458;
    let ctx2 = c2.getContext && c2.getContext('2d');
    ctx2.drawImage(this.brand_image[0], -5, -30, 950, 1444);
    let c3: any = document.createElement('canvas');
    c3.width = 954;
    c3.height = 1458;
    let ctx3 = c3.getContext && c3.getContext('2d');
    ctx3.mozImageSmoothingEnabled = false;
    ctx3.webkitImageSmoothingEnabled = false;
    ctx3.msImageSmoothingEnabled = false;
    ctx3.imageSmoothingEnabled = false;
    ctx3.drawImage(c, 0, 0, 954, 1458);
    ctx3.drawImage(c2, 10, 20, 954, 1458);
    let fullSizeCover = c3.toDataURL('image/png');
    this.TrackingManager.trackDownload();
    return fullSizeCover;
  }

  public downloadFullCover(): void {
    let image = this.generateDownloadCover();
    let isSafari = this.UserAgentManager.isSafari();
    let deviceType = this.UserAgentManager.getDevice();
    if (
      isSafari ||
      deviceType.model === 'iPhone' ||
      deviceType.model === 'iPad' ||
      deviceType.model === 'Nexus 7'
    ) {
      window.open(image);
    } else {
      download(image, 'hero-creator-cover.png', 'image/png');
    }
  }

  public printFullCover(): void {
    let printImage = new Image();
    printImage.src = this.generateCover();
    printImage.className = 'print-screen__cover';
    let container = document.querySelector('.hero-creator-container');
    container.appendChild(printImage);
    this.AngularServices.$timeout(() => {
      window.print();
    }, 200);
  }

  public getCoverDataURI(): any {
    let dataURI: string = this.renderer.view.toDataURL('image/png');
    return this.$sce.trustAsResourceUrl(dataURI);
  }

  public resetPixi(): void {
    let pixiDivContainer = document.querySelector(
      '.comic-screen__cover__container__cover'
    );
    PIXI.loader.reset();
    this.heroURI = '';
    for (let i = 0; i < this.stage.children.length; i++) {
      this.stage.removeChild(this.stage.children[i]);
    }
    while (pixiDivContainer.firstChild) {
      pixiDivContainer.removeChild(pixiDivContainer.firstChild);
    }
    this.init(pixiDivContainer);
    this.displayPixi = true;
    /*this.$timeout(() => {
      this.setCover("");
      this.stage.removeChild(this.stickerBoard);
      this.stickerBoard = new PIXI.Container();
      this.stage.addChild(this.stickerBoard);
      this.updateRender();
      this.addHeroToCover();

      $('.comic-bg-screen__cover__container__cover').detach().appendTo('.comic-bg-screen__cover__container');
      this.init(document.querySelector('.comic-bg-screen__cover__container__cover'))
    }, 500);*/
  }
}



/** WEBPACK FOOTER **
 ** ./src/common/services/pixi-manager/pixi-manager.ts
 **/